import { initSelect } from './modules/select'; // import {
//   initFilters
// } from './modules/filtering';

document.addEventListener('DOMContentLoaded', function () {
  //  initFilters();
  initSelect();
});